import script from "./PropertyAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyAdmin.vue?vue&type=script&setup=true&lang=js"

import "./PropertyAdmin.vue?vue&type=style&index=0&id=c6b12f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6b12f20"]])

export default __exports__